const regexp = {
    alpha: 'A-ZĄĆĘŚŁŃÓŻŹ',
    digits: '0-9',
    white_space: '\\s',
    dash: '-',
    apostrophe: "'’",
    /* eslint-disable no-useless-escape */
    dot: '.',
    common: '!@#$%^\\&\\*\\+\\_:;\\?\\"\\~\\/\\,\\[\\]\\(\\)',
    quote: "\\'",
    long_dash: '\\–',
    word_quotes: '„”',
    pipe: '|',
    back_slash: '\\\\',
    basic_not_allowed: '<>`{}='
};

function getRegexp (list, flags) {
    let reg = '';
    if (typeof list === 'object') {
        list.forEach((el) => {
            if (regexp[el] !== undefined) {
                reg += regexp[el];
            }
        });
    }
    return new RegExp('^[' + reg + ']*$', flags);
}

function excludedCharacters (list, flags) {
    let reg = '';
    if (typeof list === 'object') {
        list.forEach((el) => {
            if (regexp[el] !== undefined) {
                reg += regexp[el];
            }
        });
    }
    return new RegExp('^[^' + reg + ']*$', flags);
}

function getRegexpPart (list) {
    let reg = '';
    if (typeof list === 'object') {
        list.forEach((el) => {
            if (regexp[el] !== undefined) {
                reg += regexp[el];
            }
        });
    }
    return '[' + reg + ']*';
}

function requiredRegularFieldRulesWithQuotes () {
    return {
        required: true,
        not_allowed_chars: true
    };
}

function regularFieldRulesWithQuotes () {
    return {
        required: false,
        not_allowed_chars: true
    };
}

const rules = {
    first_name_non_required: {
        required: false,
        max: 255,
        regex: getRegexp(['alpha', 'white_space', 'dash', 'long_dash', 'apostrophe'], 'i')
    },
    first_name: {
        required: true,
        max: 255,
        regex: getRegexp(['alpha', 'white_space', 'dash', 'long_dash', 'apostrophe'], 'i')
    },
    last_name: {
        required: true,
        max: 255,
        regex: getRegexp(['alpha', 'white_space', 'dash', 'long_dash', 'apostrophe'], 'i')
    },
    street: {
        max: 255,
        required: true,
        // contains all allowed characters with at least one alpha
        regex: new RegExp(
            '^' +
        getRegexpPart(['alpha', 'digits', 'white_space', 'dash', 'long_dash', 'dot']) +
        '[' +
        regexp.alpha +
        ']' +
        getRegexpPart(['alpha', 'digits', 'white_space', 'dash', 'long_dash', 'dot']) +
        '$',
            'i'
        )
    },
    building_number: {
        max: 9,
        required: true,
        /* eslint-disable prefer-regex-literals */
        // becaouse in this particular case is more clear
        regex: new RegExp('^(?=.*\\d)[a-zA-Z\\d\\-\\/]{1,9}$', 'i')
    },
    flat_number: {
        max: 9,
        required: false,
        regex: new RegExp('^(?=.*\\d)[a-zA-Z\\d\\-\\/]{1,9}$', 'i')
    },
    postal_code: {
        required: true,
        min: 5,
        max: 5,
        numeric: true
    },
    city: {
        required: true,
        max: 255,
        regex: getRegexp(['alpha', 'white_space', 'long_dash', 'dot', 'dash'], 'i')
    },
    warehouseCity: {
        required: true,
        max: 180,
        not_allowed_chars: true
    },
    location: {
        required: true
    },
    email: {
        required: true,
        email: true
    },
    regex_email: {
        required: true,
        regex:
      /^(([^!#$%^&*~`/?'|{}+=<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    },
    regex_email_without_polish: {
        required: true,
        regex:
      /^(([^!#$%^&*~`/?'|{}+=<>()\[\]\\.,;:\s@"ĄĆĘŚŁŃÓŻŹąćęśłńóżź]+(\.[^<>()\[\]\\.,;:\s@"ĄĆĘŚŁŃÓŻŹąćęśłńóżź]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    },
    non_required_email: {
        required: false,
        email: true
    },
    province: {
        required: true
    },
    phone: {
        required: true,
        min: 9,
        max: 9,
        numeric: true
    },
    non_required_phone: {
        required: false,
        min: 9,
        max: 9,
        numeric: true
    },
    category: {
        required: true
    },
    corpoName: {
        required: true,
        max: 255,
        not_allowed_chars: true
    },
    nip: {
        required: true,
        min: 10,
        max: 10,
        numeric: true
    },
    regular_field: {
        required: false,
        max: 255,
        not_allowed_chars: true
    },
    regular_field_max_180: {
        required: false,
        max: 180,
        not_allowed_chars: true
    },
    required_field_max_180: {
        required: true,
        max: 180,
        not_allowed_chars: true
    },
    required_regular_field: {
        required: true,
        not_allowed_chars: true
    },
    required_min_150_field: {
        required: true,
        min: 150,
        not_allowed_chars: true
    },
    min_150_field: {
        min: 150,
        not_allowed_chars: true
    },
    radio_buttons: {
        required: true
    },
    age: {
        numeric: true,
        max: 3
    },
    terms_and_conditions: {
        required: true
    },
    person_data_mail_consent: {
        required: false
    },
    search_field: {
        required: true,
        min: 3,
        regex: /[^<>`{}=?!#"$%~+^&*_'\\,()\[\]:;|]$/
    },
    amount_on_medicine: {
        required: true,
        custom_decimal: true
    },
    disease: {
        required: true,
        not_allowed_chars: true
    },
    required_money: {
        required: true,
        custom_decimal: true
    },
    non_required_money: {
        required: false,
        custom_decimal: true
    },
    credit_amount: {
        required: true,
        custom_decimal: true
    },
    remains_to_repair: {
        required: true,
        custom_decimal: true
    },
    month_credit_amount: {
        required: true,
        custom_decimal: true
    },
    arrears_amount: {
        required: true,
        custom_decimal: true
    },
    active_members_position: {
        required: true,
        not_allowed_chars: true
    },
    active_member_dimension: {
        required: true
    },
    active_members_amount: {
        required: true,
        custom_decimal: true
    },
    another_sources: {
        required: true,
        not_allowed_chars: true
    },
    another_incomes_amount: {
        required: true,
        custom_decimal: true
    },
    another_incomes_persons: {
        required: true
    },
    ready_to_change: {
        required: true
    },
    other_preclude_factors: {
        required: true,
        not_allowed_chars: true
    },
    meeting_summary_factors: {
        required: true,
        not_allowed_chars: true
    },
    reflection_resources: {
        required: true,
        not_allowed_chars: true
    },
    reflection_barriers: {
        required: true,
        not_allowed_chars: true
    },
    reflection_summary: {
        required: true,
        not_allowed_chars: true
    },
    interview_date: {
        required: true
    },
    decision_turn_on: {
        required: true,
        not_allowed_chars: true
    },
    decision_non_inclusion: {
        required: true,
        not_allowed_chars: true
    },
    first_meeting: {
        required: true,
        not_allowed_chars: true
    },
    changed_name: {
        required: true,
        max: 255,
        regex: getRegexp(['alpha', 'white_space', 'dash', 'long_dash', 'apostrophe'], 'i')
    },
    food: {
        required: true,
        not_allowed_chars: true
    },
    cleaningProducts: {
        required: true,
        not_allowed_chars: true
    },
    paper_document: {
        required: true
    },
    clothesType: {
        required: true
    },
    clothesCategory: {
        required: true
    },
    clothesSize: {
        required: true
    },
    clothesNote: {
        required: false,
        not_allowed_chars: true
    },
    footwearCategory: {
        required: true
    },
    footwearSize: {
        required: true
    },
    footwearNote: {
        required: false,
        not_allowed_chars: true
    },
    schoolSupplies: {
        required: true,
        not_allowed_chars: true
    },
    anotherApartmentsEquipment: {
        required: true,
        not_allowed_chars: true
    },
    apartmentsEquipmentNote: {
        required: false,
        not_allowed_chars: true
    },
    anotherAppliances: {
        required: true,
        not_allowed_chars: true
    },
    appliancesNotes: {
        required: false,
        not_allowed_chars: true
    },
    fuelType: {
        required: true
    },
    otherFuelType: {
        required: true,
        not_allowed_chars: true
    },
    fuelAmount: {
        required: true,
        not_allowed_chars: true
    },
    anotherMaterialNeeds: {
        required: true,
        not_allowed_chars: true
    },
    intangibleNeeds: {
        required: true,
        not_allowed_chars: true
    },
    specialGift: {
        required: true,
        not_allowed_chars: true
    },
    importantNeeds: {
        required: true,
        not_allowed_chars: true
    },
    importantNote: {
        required: true,
        not_allowed_chars: true
    },
    personalDataConsent: {
        required: true
    },
    reflection_notes: {
        required: true,
        not_allowed_chars: true
    },
    long_regular_field: {
        required: false,
        max: 1800,
        not_allowed_chars: true
    },
    addWarehouseBaseParameters: {
        required: true
    },
    wayForWarehouseOperation: {
        required: true,
        not_allowed_chars: true,
        max: 1800
    },
    warehouseName: {
        required: true,
        not_allowed_chars: true,
        max: 180
    },
    warehouseSize: {
        required: true,
        regex: new RegExp('^([0-9]{1,7})(([.,])[0-9]{1,2})?$'),
        excluded: 0
    },
    warehouseHasInternet: {
        required: true
    },
    managerCandidates: {
        required: true
    },
    warehouseManager: {
        required: true
    },
    supportingWarehouseType: {
        required: true
    },
    whyThisLocation: {
        required: true,
        not_allowed_chars: true,
        max: 1800
    },
    addWarehouseCosts: {
        required: true,
        custom_decimal: true,
        max: 10
    },
    addWarehouseCostsNonRequired: {
        required: false,
        custom_decimal: true,
        max: 10
    },
    addWarehouseBarter: {
        required: true,
        not_allowed_chars: true,
        max: 1800
    },
    addWarehouseBarterNonRequired: {
        required: false,
        not_allowed_chars: true,
        max: 1800
    },
    warehouseDirections: {
        required: true,
        not_allowed_chars: true,
        max: 1800
    },
    warehouseDirectionsNonRequired: {
        required: false,
        not_allowed_chars: true,
        max: 1800
    },
    giftgiverFormOfContact: {
        required: false,
        not_allowed_chars: true
    },
    noneRequiredCheckbox: {
        required: false
    },
    editReason: {
        required: true,
        not_allowed_chars: true
    },
    packsAmount: {
        required: true,
        numeric: true,
        max: 10
    },
    describeGiftGiver: {
        ...requiredRegularFieldRulesWithQuotes()
    },
    familyReaction: {
        ...requiredRegularFieldRulesWithQuotes()
    },
    wasAbsent: {
        ...requiredRegularFieldRulesWithQuotes()
    },
    packQualityArguments: {
        ...requiredRegularFieldRulesWithQuotes()
    },
    packItems: {
        ...requiredRegularFieldRulesWithQuotes()
    },
    describeIntangibleNeeds: {
        ...requiredRegularFieldRulesWithQuotes()
    },
    newMeetingWithFamily: {
        ...requiredRegularFieldRulesWithQuotes()
    },
    deliveryReport: {
        min: 200,
        ...requiredRegularFieldRulesWithQuotes()
    },
    familyWords: {
        ...regularFieldRulesWithQuotes()
    },
    volunteerWords: {
        min: 200,
        ...requiredRegularFieldRulesWithQuotes()
    },
    auditComment: {
        not_allowed_chars: true
    }
};

export const FIELD_LENGTH = {
    MIN_SHORT_FIELD_LENGTH: 200,
    MIN_MIDDLE_FIELD_LENGTH: 300,
    MAX_LONG_FIELD_LENGTH: 4000
};

export default {
    get (rule) {
        if (rules[rule] === undefined) {
            throw new Error('undefined rule');
        }

        return rules[rule];
    }
};

export { excludedCharacters };
